import type { NotePayload } from '../schema';
import { getNoteColor } from '../selectors/getNoteColor';

export default function getBackgroundColor({ remoteId }: NotePayload) {
    return remoteId ? getNoteColor(remoteId) : '';
}
